


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { RootState } from '@/store/types';
import { Device, DeviceState, DeviceFirmware } from '@/store/device/types';
import Alert from '@/components/Alert.vue';

const namespace: string = 'device';

@Component({
  components: {
    Alert,
  },
})
export default class DeviceActivationForm extends Vue {
  @Action('getDevices', { namespace }) private getDevices: () => Device[];
  @Action('rebootDevice', { namespace }) private rebootDevice: (
    device: Device,
  ) => void;
  @Action('connectDevice', { namespace }) private connectDevice: (
    device: Device,
  ) => void;
  @Action('updateFirmware', { namespace }) private updateFirmware: (
    deviceFirmware: DeviceFirmware,
  ) => void;
  @Action('updateDeviceActivation', { namespace })
  private updateDeviceActivation: (device: Device) => Device[];
  @Getter('sortedDevices', { namespace })
  private sortedDevices: string;
  @State('device')
  private deviceState: DeviceState;

  private columns: string[] = [
    // '_id',
    'mac',
    // 'ip',
    'm1',
    'm2',
    // 'remoteAddress',
    'sigfoxSerial',
    // 'sigfoxPac',
    // 'connected',
    'activated',
    'acct',
  ];

  constructor() {
    super();
  }

  public onConnecDevice(device: Device) {
    this.connectDevice(device);
  }

  public mounted() {
    this.getDevices();
  }

  private onChangeActivation(device: Device) {
    this.updateDeviceActivation(device);
  }

  private onRebootDevice(device: Device, message: string) {
    if (confirm(message)) {
      this.rebootDevice(device);
    }
  }

  private canConnectDevice(device: Device): boolean {
    return (
      device !== undefined &&
      device.adConnectDevice !== undefined &&
      Array.isArray(device.adConnectDevice.expose) &&
      (device.adConnectDevice.expose.indexOf('http') > -1 ||
        device.adConnectDevice.expose.indexOf('https') > -1)
    );
  }

  private onUpdateFirmware(d: Device, version: string, message: string) {
    if (confirm(message)) {
      this.updateFirmware({
        device: d,
        firmware: version,
      });
    }
  }
}
